export interface PackageDayTripEntry {
    day_trip_id: string
    day_trip_name: string
    /** Set when loaded from API */
    package_day_trip_id?: string | null
}

export interface PackageTripPriceEntry {
    seating_type_id: number
    seating_type_name: string
    price: number
    /** Set when loaded from API */
    trip_pricing_id?: string | null
}

export interface PackageDetailModel {
    package_id: string
    package_name: string
    flag_active: boolean
    package_day_trip: PackageDayTripEntry[]
    package_trip_price: PackageTripPriceEntry[]
}

const SEATING_TYPES = [
    { seating_type_id: 1, seating_type_name: "4 Seater" },
    { seating_type_id: 2, seating_type_name: "7 Seater" },
    { seating_type_id: 3, seating_type_name: "16 Seater" },
    { seating_type_id: 4, seating_type_name: "29 Seater" },
    { seating_type_id: 5, seating_type_name: "35 Seater" },
    { seating_type_id: 6, seating_type_name: "45 Seater" },
    { seating_type_id: 7, seating_type_name: "SIC" },
] as const

const DEFAULT_EMPTY_TRIP: PackageDayTripEntry = {
    day_trip_id: "",
    day_trip_name: "",
}

export function getEmptyPackageDetail(): PackageDetailModel {
    return {
        package_id: "",
        package_name: "",
        flag_active: false,
        package_day_trip: [{ ...DEFAULT_EMPTY_TRIP }],
        package_trip_price: SEATING_TYPES.map((st) => ({
            seating_type_id: st.seating_type_id,
            seating_type_name: st.seating_type_name,
            price: 0,
        })),
    }
}
